export default __webpack_public_path__ + "static/remedial-81aa9236aeaae099bff550ec76d9bae0.jpg";